var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNoteTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71122_17756)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13.3C10.4794 13.3 13.3 10.4795 13.3 7C13.3 3.52061 10.4795 0.699985 7 0.699985C3.52061 0.699985 0.699985 3.52061 0.699985 7C0.699985 10.4794 3.52061 13.3 7 13.3ZM7 14C10.8659 14 14 10.8659 14 7C14 3.13398 10.8659 0 7 0C3.13398 0 0 3.13398 0 7C0 10.8659 3.13398 14 7 14Z",
    fill: "#004EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79998 6.99843C9.79998 7.19167 9.64323 7.34842 9.44999 7.34842H4.54994C4.35663 7.34842 4.19995 7.19167 4.19995 6.99843C4.19995 6.80519 4.35663 6.64844 4.54994 6.64844H9.44991C9.64323 6.64844 9.79998 6.80519 9.79998 6.99843Z",
    fill: "#004EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99989 9.79925C6.80665 9.79925 6.6499 9.6425 6.6499 9.44926V4.54921C6.6499 4.3559 6.80665 4.19922 6.99989 4.19922C7.19314 4.19922 7.34989 4.3559 7.34989 4.54921V9.44918C7.34989 9.6425 7.19314 9.79925 6.99989 9.79925Z",
    fill: "#004EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71122_17756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNoteTask);
export default __webpack_public_path__ + "static/media/AddNoteTask.fa50e60e660001b8f46aa610dc32b134.svg";
export { ForwardRef as ReactComponent };